import { Table } from '@mantine/core';
import { useState } from 'react';
import { KeyedRow } from '../../../components/KeyedRow';
import {
	formatToCurrency,
	formatToDateStringOrDefault,
	formatToTimeStringOrDefault,
} from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { BankingTotalDto } from '../types/BankingTotalDto';

export default function BankingTotalsRow({
	initialBank,
}: { initialBank: BankingTotalDto }) {
	const [banking, setBanking] = useState(initialBank);

	return (
		<>
			<KeyedRow>
				<Table.Td>{banking.branchName}</Table.Td>
				<Table.Td>{formatToCurrency(banking.bankingValue)}</Table.Td>
				<Table.Td>{formatToDateStringOrDefault(banking.dateTime)}</Table.Td>
				<Table.Td>{formatToTimeStringOrDefault(banking.dateTime)}</Table.Td>
				<Table.Td>{undefinedCheck(banking.userName)}</Table.Td>
			</KeyedRow>
		</>
	);
}
